import { getSafeArray } from './safeStorage';

const STORAGE_KEY = 'domains';
let inMemoryDomains = [];

export const persistDomainsList = (domainsList) => {
  if (!Array.isArray(domainsList) || domainsList.length === 0) {
    return false;
  }

  inMemoryDomains = domainsList;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(domainsList));
    return true;
  } catch (error) {
    console.error('Failed to persist domains list:', error);
    return false;
  }
};

export const readStoredDomains = () => {
  const stored = getSafeArray(STORAGE_KEY, []);
  if (Array.isArray(stored) && stored.length > 0) {
    inMemoryDomains = stored;
    return stored;
  }
  return Array.isArray(inMemoryDomains) ? inMemoryDomains : [];
};

export const mergeProtectedDomains = (incomingList, cachedList = readStoredDomains()) => {
  if (Array.isArray(incomingList) && incomingList.length > 0) {
    persistDomainsList(incomingList);
    return incomingList;
  }
  return Array.isArray(cachedList) && cachedList.length > 0 ? cachedList : [];
};

export const resetDomainStorageForTests = () => {
  inMemoryDomains = [];
};

export const getAuthHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };
  if (typeof window === 'undefined') return headers;

  const token = sessionStorage.getItem('access_token');
  const graphToken = sessionStorage.getItem('graph_token');
  const refreshToken = sessionStorage.getItem('refresh_token');

  if (token) headers.Authorization = `Bearer ${token}`;
  if (graphToken) headers['X-Graph-Token'] = graphToken;
  if (refreshToken) headers['X-Refresh-Token'] = refreshToken;
  return headers;
};
